var map = {
	"./medal-arrow.png": "0610",
	"./medal-bg.png": "78fe",
	"./medal1.png": "b62a",
	"./medal10.png": "16cc",
	"./medal11.png": "6465",
	"./medal2.png": "a14c",
	"./medal2025.png": "21c5",
	"./medal3.png": "9f3a",
	"./medal4.png": "7b1f",
	"./medal5.png": "632a",
	"./medal6.png": "7b91",
	"./medal7.png": "aa74",
	"./medal8.png": "c1b9",
	"./medal9.png": "ad19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0729";